import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';

export const ActivityContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    & .infinite-scroll-component {
        width: 800px;

        @media (max-width: 1150px) {
            width: 532px;
        }

        ${media.tablet`
            width: 680px;
        `};

        ${media.phone`
            width: 100%;
            justify-content: center;
        `};
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/ActivityList/style.js